import { useId } from 'react';

import { ModalShell } from './surface';

/**
 * 삭제 확인 대화상자 — 회차 하나 삭제(결과 상세)와 전부 삭제(MY)가 같이 쓴다(두 feature 공용이라
 * `app/components/`). `LeaveDialog` 와 같은 모양(제목 · 본문 · 취소/확인 두 알약)이다.
 *
 * - **기본 포커스는 취소다** — 되돌리기 어려운 동작이라 Enter 한 번으로 지워지면 안 된다.
 * - **`busy` 중에는 닫히지 않는다** — Esc·배경·취소가 모두 막힌다. 순회는 화면을 닫아도 서버에서
 *   계속 돌므로, 닫아 버리면 진행 중인지 알 길이 없다. 확인 버튼도 같이 잠겨 두 번 눌러도 한 번이다.
 */
export const DeleteConfirmDialog = ({
  title,
  body,
  confirmLabel,
  cancelLabel,
  busy = false,
  onConfirm,
  onCancel,
}: {
  title: string;
  body: string;
  confirmLabel: string;
  cancelLabel: string;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}) => {
  const titleId = useId();
  return (
    <ModalShell
      labelledBy={titleId}
      dismissLabel={cancelLabel}
      onDismiss={busy ? () => undefined : onCancel}
      className="px-5 pb-5 pt-8"
    >
      <h2
        id={titleId}
        className="text-lg font-semibold tracking-[-0.18px] text-bk-900"
      >
        {title}
      </h2>
      <p className="mt-2 whitespace-pre-line break-keep text-sm leading-relaxed text-bk-600">
        {body}
      </p>
      <div className="mt-6 flex gap-2">
        <button
          type="button"
          autoFocus
          disabled={busy}
          onClick={onCancel}
          className="h-[54px] flex-1 rounded-full border border-bk-300 bg-white text-base font-semibold text-bk-900 disabled:opacity-40"
        >
          {cancelLabel}
        </button>
        <button
          type="button"
          disabled={busy}
          onClick={onConfirm}
          className="h-[54px] flex-1 rounded-full bg-bk-900 text-base font-semibold text-white disabled:opacity-40"
        >
          {confirmLabel}
        </button>
      </div>
    </ModalShell>
  );
};
